<template>
  <div class="fit-container fit-password">
    <p class="fit-password-title">{{title}}</p>
    <div class="fit-password-content flex-center" @click.stop="eClick">
      <span
        v-for="(item,id) in content"
        :key="id"
        :class="{'fit-password-encoded': item.isEncoded}"
      >{{item.v || ''}}</span>
    </div>
  </div>
</template>
<script>
import mixins from '../../../common/mixin';

export default {
  name: 'fit-password',
  mixins,
  props: {
    title: {
      type: String,
      required: true,
    },
    length: {
      type: [Number, String],
      default: 6,
      validator(value) {
        const v = parseInt(value, 10);
        return !isNaN(v) && v >= 4 && v <= 10;
      },
    },
    value: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    content() {
      const value = String(this.value);
      const { length } = this;
      const ret = [];
      const { visible } = this;
      let i;
      let v;
      for (i = 0; i < length; i++) {
        // eslint-disable-next-line no-nested-ternary
        v = value.charAt(i) ? (!visible ? '*' : value.charAt(i)) : '';
        ret.push({
          v,
          isEncoded: v === '*',
        });
      }
      return ret;
    },
  },
  watch: {
    value() {
      setTimeout(() => {
        let value;
        let ret = '';
        if (this.value.length >= this.length) {
          value = this.value.slice(0, this.length);
          ret = (function (v) {
            const r = [];
            let i;
            let l;
            for (i = 0, l = v.length; i < l; i++) {
              r.push(v[i]);
            }
            return r;
          }(value));
          this.$emit('filled', ret);
        }
      }, 10);
    },
  },
  methods: {
    eClick() {
      this.$emit('click');
    },
  },
};
</script>
